import Vue from 'vue'
import VueRouter from 'vue-router'
import Dashboard from '@/views/Dashboard.vue'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: { name: 'dashboard' },
      meta: {
        auth: true
      }
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      meta: {
        auth: true
      }
    },
    {
      path: '/services',
      name: 'services',
      component: () => import(/* webpackChunkName:  "service"  */ '@/views/Services.vue'),
      meta: {
        title: Vue.i18n.translate('strings.services', null),
        auth: true
      },
      children: [{
        path: ':id',
        name: 'serviceDetail',
        component: () => import(/* webpackChunkName:  "service"  */ '@/views/Services.vue')
      }]
    },
    {
      path: '/Charges',
      name: 'Charges',
      component: () => import(/* webpackChunkName:  "Charge"  */ '@/views/Charges.vue'),
      meta: {
        title: Vue.i18n.translate('strings.Charges', null),
        auth: true
      }
    },
    {
      path: '/payments',
      name: 'payments',
      component: () => import(/* webpackChunkName:  "payment"  */ '@/views/Payments.vue'),
      meta: {
        title: Vue.i18n.translate('strings.payments', null),
        auth: true
      },
      children: [{
        path: ':id',
        name: 'paymentDetail',
        component: () => import(/* webpackChunkName:  "payment"  */ '@/views/Payments.vue')
      }]
    },
    {
      path: '/reports',
      name: 'reports',
      component: () => import(/* webpackChunkName:  "payment"  */ '@/views/Reports.vue'),
      meta: {
        title: Vue.i18n.translate('strings.reports', null),
        auth: true
      },
      children: [{
        path: ':id',
        name: 'paymentDetail',
        component: () => import(/* webpackChunkName:  "payment"  */ '@/views/Reports.vue')
      }]
    },
    {
      path: '/reports',
      name: 'reports',
      component: () => import(/* webpackChunkName:  "report"  */ '@/views/Reports.vue'),
      meta: {
        title: Vue.i18n.translate('strings.reports', null),
        auth: true
      },
      children: [{
        path: ':id',
        name: 'reportDetail',
        component: () => import(/* webpackChunkName:  "report"  */ '@/views/Reports.vue')
      }]
    },
    // New Route
    {
      path: '/doctors',
      name: 'doctors',
      component: () => import(/* webpackChunkName: "users" */ '@/views/Doctors.vue'),
      meta: {
        title: Vue.i18n.translate('strings.doctors', null),
        auth: {
          roles: 'Admin',
          forbiddenRedirect: '/'
        }
      },
      children: [{
        path: ':id',
        name: 'userDetail',
        component: () => import(/* webpackChunkName: "doctors" */ '@/views/Doctors.vue')
      }]
    },
    {
      path: '/patient',
      name: 'patient',
      component: () => import(/* webpackChunkName: "users" */ '@/views/Patient.vue'),
      meta: {
        title: Vue.i18n.translate('strings.patient', null),
        auth: {
          roles: 'Admin',
          forbiddenRedirect: '/'
        }
      },
      children: [{
        path: ':id',
        name: 'userDetail',
        component: () => import(/* webpackChunkName: "patient" */ '@/views/Patient.vue')
      }]
    },
    {
      path: '/certifications',
      name: 'certifications',
      component: () => import(/* webpackChunkName: "certifications" */ '@/views/Certifications.vue'),
      meta: {
        title: Vue.i18n.translate('strings.certifications', null),
        auth: {
          roles: 'Admin',
          forbiddenRedirect: '/'
        }
      },
      children: [{
        path: ':id',
        name: 'certificationsDetail',
        component: () => import(/* webpackChunkName: "certifications" */ '@/views/Certifications.vue')
      }]
    },
    // New Route
    {
      path: '/users',
      name: 'users',
      component: () => import(/* webpackChunkName: "users" */ '@/views/Users.vue'),
      meta: {
        title: Vue.i18n.translate('strings.users', null),
        auth: {
          roles: 'Admin',
          forbiddenRedirect: '/'
        }
      },
      children: [{
        path: ':id',
        name: 'userDetail',
        component: () => import(/* webpackChunkName: "users" */ '@/views/Users.vue')
      }]
    },
    {
      path: '/login',
      name: 'login',
      // route level code-splitting
      // this generates a separate chunk (login.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "login" */ '@/views/Auth/AuthLogin.vue'),
      meta: {
        title: Vue.i18n.translate('login.login', null),
        auth: false
      }
    },
    {
      path: '/register',
      name: 'register',
      // route level code-splitting
      // this generates a separate chunk (register.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "register" */ '@/views/Auth/AuthRegister.vue'),
      meta: {
        title: Vue.i18n.translate('login.register', null),
        auth: false
      }
    },
    {
      path: '/password/reset',
      name: 'reset',
      component: () => import(/* webpackChunkName: "Reset" */ '@/views/Auth/AuthResetLink.vue'),
      meta: {
        title: Vue.i18n.translate('login.reset_password', null),
        auth: false
      }
    },
    {
      path: '/password/reset/:token',
      name: 'reset.token',
      component: () => import(/* webpackChunkName: "Reset" */ '@/views/Auth/AuthResetForm.vue'),
      meta: {
        title: Vue.i18n.translate('login.reset_password', null),
        auth: false
      }
    },
    {
      path: '/email/verify',
      name: 'verification.notice',
      props: true,
      component: () => import(/* webpackChunkName: "verification" */ '@/views/Auth/AuthVerify.vue'),
      meta: {
        title: Vue.i18n.translate('verification.title', null),
        auth: false
      }
    }
  ]
})

// It's required for VueAuth
Vue.router = router

export default router
